import api from '@/services/apiService';

export interface InvasionPlayerStats {
  id?: number;
  matchId?: number;
  matchPlayerId?: number;
  userId?: number;
  role: string;
  goals: number;
  assists: number;
  keyPasses: number;
  clearances: number;
  saves: number;
  isCleanSheet: boolean;
  freestyles: number;
  foulsBlunders: number;
  ownGoals?: number;
  individualScore?: number;
  deltaMmr?: number;
}

export interface InvasionMatchPlayer {
  id: number;
  matchId: number;
  userId: number;
  participantId: number;
  team: 'A' | 'B';
  role: string; // 'FW', 'MF', 'DF', 'GK', 'N'
  isOnField: boolean;
  minutesPlayed: number;
  user?: {
    id: number;
    name: string;
    email: string;
    nickname?: string;
  };
  stats?: InvasionPlayerStats;
}

export interface InvasionMatch {
  id: number;
  sessionId: number;
  eventId: number;
  matchNumber: number;
  slug: string;
  teamAName: string;
  teamBName: string;
  scoreTeamA?: number;
  scoreTeamB?: number;
  winnerTeam?: 'A' | 'B' | 'D';
  status: 'scheduled' | 'in_progress' | 'completed';
  createdAt: string;
  updatedAt: string;
  players?: InvasionMatchPlayer[];
}

export interface InvasionSession {
  id: number;
  eventId: number;
  slug: string;
  title: string;
  numMatches: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  event?: {
    id: number;
    name: string;
    slug: string;
    sport_category?: {
      id: number;
      name: string;
      slug: string;
    };
  };
  matches?: InvasionMatch[];
}

export interface CreateMatchPlayerPayload {
  userId: number;
  participantId: number;
  team: 'A' | 'B';
  role: string;
}

export interface CreateMatchPayload {
  matchNumber: number;
  teamAName: string;
  teamBName: string;
  players: CreateMatchPlayerPayload[];
}

export interface RecordPlayerStatPayload {
  matchPlayerId: number;
  goals: number;
  assists: number;
  keyPasses: number;
  clearances: number;
  saves: number;
  isCleanSheet: boolean;
  freestyles: number;
  foulsBlunders: number;
  ownGoals?: number;
}

export interface RecordMatchStatsPayload {
  scoreTeamA: number;
  scoreTeamB: number;
  playerStats: RecordPlayerStatPayload[];
}

const invasionService = {
  /** Get or auto-create Invasion session and matches for an event */
  async getInvasionSession(eventSlug: string): Promise<InvasionSession> {
    const res = await api.get(`/mabar/events/${eventSlug}/invasion`);
    return res.data.data;
  },

  /** Create a new Invasion match within an event session */
  async createMatch(eventSlug: string, payload: CreateMatchPayload): Promise<InvasionMatch> {
    const res = await api.post(`/mabar/events/${eventSlug}/invasion/matches`, payload);
    return res.data.data;
  },

  /** Finalize match, calculate MMR, and push MMR delta to all players */
  async finalizeMatch(
    eventSlug: string,
    matchId: number,
    payload: RecordMatchStatsPayload
  ): Promise<InvasionMatch> {
    const res = await api.post(
      `/mabar/events/${eventSlug}/invasion/matches/${matchId}/finalize`,
      payload
    );
    return res.data.data;
  },
};

export default invasionService;
